<template>
  <!--
    REQ FOR
    2FA TOKEN VIA SMS
   -->
  <el-form :ref="formName" :model="form" :rules="rules" @submit.native.prevent>
    <el-alert v-if="error" title="Authentication failed" type="error" :description="error" show-icon></el-alert>
    <el-form-item label="Token" :inline-message="true" prop="token">
      <el-input v-model="form.token" size="medium"/>
    </el-form-item>
    <span class="text-muted">Your token expires in 2 minutes</span>
    <div class="form-action">
      <el-button type="primary" class="btn-submit" :disabled="loading" @click="submitForm()">Continue</el-button>
      <p class="token-footer">
        <el-button type="text" @click="forgotPhone">Click here</el-button>
        if you have a new mobile number and would like to update your member record.
        If you do not have access to your mobile number then please call 02 8356 0300.
      </p>
    </div>
  </el-form>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {submitMixin} from "./_submitMixin"

export default {
  mixins: [submitMixin],
  data() {
    return {
      formName: 'tokenForm',
      form: {
        token: ''
      },
      rules: {
        token: {
          required: true,
          message: "Token is required",
          trigger: "blur"
        }
      }
    }
  },
  mounted() {
    // add event listener for enter key and submit form
    document.addEventListener('keyup', this.enterKeySubmit);
  },
  computed: {
    ...mapState({
      loading: state => state.auth.loading,
      error: state => state.auth.error
    }),
  },
  methods: {
    ...mapActions('auth', ['verifyToken', 'forgotPhone']),
    enterKeySubmit(e) {
      if (e.keyCode === 13) {
        this.submitForm('tokenForm');
      }
    },
    submitForm() {
      this.$refs[this.formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }

        await this.verifyToken(this.form.token);
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  .text-muted {
    display: inline-block;
    color: #606266;
    font-size: 0.825rem;
    font-style: italic;
    margin-bottom: 10px;
  }

  .el-alert {
    margin-bottom: 15px;
  }

  .el-form-item {
    .el-form-item__label {
      line-height: 22px;
      font-weight: bold;
    }

    .el-form-item__content {
      .el-form-item__error {
        padding-top: 0;
        padding-bottom: 4px;
      }
    }
  }
}

.form-action {
  margin-top: 30px;

  .btn-submit {
    font-weight: bold;
    font-size: 16px;
    width: 100%;
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .token-footer {
    font-size: 0.925rem;
    line-height: 22px;
    margin-bottom: 0;

    .el-button--text {
      margin-left: 0;
      color: #67C23A;
      padding-top: 6px;
      padding-bottom: 0;

      &:hover {
        font-weight: bold;
      }
    }
  }
}
</style>
